module.exports = "https://www.niulinkcloud.com/_next/static/media/pc.1f9612123689da3eb7ccb9fe2d313ad5.png";